import { createNewSubAccountAlert } from "./API";

const CreateNewSubAccountAlert = async (
    subAccountName,
    hashrateThreshold,
    activeWorkersThreshold,
    emailList,
    accessToken
) => {
    try {
        const response = await createNewSubAccountAlert(
            subAccountName,
            hashrateThreshold,
            activeWorkersThreshold,
            emailList,
            accessToken
        );
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, data: error.response.data.message };
    }
};

export default CreateNewSubAccountAlert;
